<template>
	<div class="container">
		<el-breadcrumb separator-class="el-icon-arrow-right" class="width p_t2 p_b2 font_16">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/newsList' }" v-if="type === 1">新闻中心</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/yjNews' }" v-if="type === 2">奕杰动态</el-breadcrumb-item>
			<el-breadcrumb-item>详情</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="p2 box_sizing">
			<h2 class="m_b2 m_t2">{{info.title}}</h2>
			<p class="m_b2" v-html="info.content">{{info.content}}</p>
		</div>

	</div>
</template>

<script>
import { ImgUrl, OSSImgUrl } from '../api/common_api';
import {newsDetail} from "../api/api";


export default {
	name: 'NewsDetail',
	data() {
		return {
			new_bsh: ImgUrl + 'new_bsh.png',
			new_xqjy: ImgUrl + 'new_xqjy.png',
			new_xqjy2: ImgUrl + 'new_xqjy2.png',
			new_jxpx: ImgUrl + 'new_jxpx.png',
			new_jxpx2: ImgUrl + 'new_jxpx2.png',
			new_hzdsj1: ImgUrl + 'new_hzdsj1.jpg',
			new_hzdsj2: ImgUrl + 'new_hzdsj2.jpg',
			new_hzdsj3: ImgUrl + 'new_hzdsj3.jpg',
			new_hzdsj4: ImgUrl + 'new_hzdsj4.jpg',
			new_hzdsj5: ImgUrl + 'new_hzdsj5.jpg',
			new_hzdsj6: ImgUrl + 'new_hzdsj6.jpg',
			new_hzdsj7: ImgUrl + 'new_hzdsj7.jpg',
			new_jxs: ImgUrl + 'new_jxs.png',
			new_hfhd1: ImgUrl + 'new_hfhd1.png',
			new_hfhd2: ImgUrl + 'new_hfhd2.png',
			new_hfhd3: ImgUrl + 'new_hfhd3.png',
			new_xj1: ImgUrl + 'new_xj1.png',
			new_xj2: ImgUrl + 'new_xj2.png',
			type: 1, //区分是新闻中心还是奕杰动态
			id: 0, //显示哪条新闻
			conType: 0,  //类型 1:文章 2:视频 3:活动
			info: {},	//页面内容
		};
	},
	created() {
		this.type = JSON.parse(this.$route.query.type);
		this.id = JSON.parse(this.$route.query.id);
		//详情查询
		this.findInfoDetail(this.id);
	},
	mounted() {

	},
	methods: {
		/**
		 * 详情查询
		 */
		findInfoDetail(id) {
			this.$loading({
				text: "加载中...",
				background: 'rgba(0, 0, 0, 0.2)'
			});
			newsDetail({
				id: id
			}).then(res => {
				this.$loading().close();
				let _data = res.data,
					tmp_info = {};
				this.conType = _data.type;
				if (_data.type === 2) { //视频
					tmp_info = {
						videoSrc: (OSSImgUrl + _data.content.split(';')[0]),
						title: _data.title,
						poster: OSSImgUrl + (_data.image.split(';')[0]),
						updateTime: _data.updateTime,
					}
				} else {  //文章和活动
					tmp_info = {
						content: _data.content,
						title: _data.title,
						updateTime: _data.updateTime,
						kindName: _data.kindergartenDetail ? (_data.kindergartenDetail.kindName ? _data.kindergartenDetail.kindName : '') : '', //企业名称-用于标是哪一个企业发布的推广
					}
				}
				this.info = tmp_info;
			}).catch(err => {
				console.log(err)
			})
		},
	}
};
</script>

<style scoped lang="stylus">
.container {
    width 1000px
    margin 0 auto

    >>> .el-breadcrumb__inner:hover {
        color #f16765
    }
    h2 {
        text-align center
        font-size 24px
        font-weight bold
        margin-bottom: 40px;
    }
    p {
        max-width 960px
        /*max-width 1160px*/
        /*text-indent 40px*/
        font-size 18px
        text-align justify
		text-justify: distribute
        line-height 36px
    }
    img {
        width auto
        height auto
        max-width 960px
        /*max-width 1160px*/
        display block
        margin 0 auto
        margin-bottom 20px
    }
}
</style>
